import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {TeamNavLinkComponent} from './team-nav-link.component';
import {ProgressSpinnerModule} from '../../../dumb/progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [TeamNavLinkComponent],
  imports: [CommonModule, RouterModule, MatIconModule, ProgressSpinnerModule],
  exports: [TeamNavLinkComponent],
})
export class TeamNavLinkModule {}
